import { createAsyncThunk } from '@reduxjs/toolkit'

import restClient, { ApiRejectResponse, validateApiError } from 'lib/api/restClient'
import apiRoutes from 'lib/api/apiRoutes'

export interface IpirToken {
  products: string[]
  provider?: string | null
}

export interface IpirAccountResponse {
  accessTokens: IpirToken[]
}

export const getIpirAccount = createAsyncThunk<IpirAccountResponse, undefined, ApiRejectResponse>(
  'IPIR/getIpirAccount',
  async (_, { rejectWithValue }) => {
    try {
      const res = await restClient(apiRoutes.GET_IPIR_ACCOUNT)
      return res.data
    } catch (e) {
      return rejectWithValue(validateApiError(e))
    }
  }
)
